import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { ServiceModel } from 'types/api'
import { BaseParams } from 'types/utils'
import { servicesQueryKey } from './useServices'

export function usePatchService() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()

  async function patchService({ id, body }: BaseParams<ServiceModel, 'PATCH'>) {
    const response = await apiClient.patch(SNA_PREFIX + `services/${id}/`, body)
    return response.data
  }

  return useMutation({
    mutationFn: patchService,
    onSuccess: () => {
      toast.success({ message: t('serviceUpdated') })
      queryClient.invalidateQueries({ queryKey: [...servicesQueryKey] })
    },
    onError: () => {
      toast.error({ message: t('serviceUpdateError') })
    }
  })
}
